import React from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from '@/components/TextComponent';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';

import { useSbkBetSlipStore } from '../../hooks/use-sbk-betslip-store';
import { generateSgpOddsId } from '../../utils/betslip-utils';

type DisabledSelectionsHeaderProps = {
    eventId: string;
};

export const DisabledSelectionsHeader = ({ eventId }: DisabledSelectionsHeaderProps) => {
    const { t } = useTranslation('betslip_sbk');

    const displayMessage = useSbkBetSlipStore(state => {
        // Check for conflicting selections using ALL selections for this event
        const allSelectionIdsForEvent = Object.values(state.selections)
            .filter(s => s.eventId === eventId)
            .map(s => s.id);
        const sgpId = generateSgpOddsId(allSelectionIdsForEvent, eventId);
        const isConflicting = state.sgpOdds[sgpId] === false;

        if (isConflicting) {
            return t('event_conflicting_selections_warning');
        }

        // Check for temporary issue
        if (state.sgpTemporaryIssue[eventId]) {
            return t('error_calculating_combo_warning');
        }

        // Default: SGP disabled for event
        return t('event_one_leg_only_warning');
    });

    return (
        <Box mb="s8">
            <Text variant="bodySmall" color={ds.colorToken.text.warning}>
                {displayMessage}
            </Text>
        </Box>
    );
};
